import { Heading } from '@efdigital/ll-addon-ui';
import GoalTracker from '@efdigital/ll-xceed-v2/components/coaching/goal-tracker.gts';
import GoalsList from '@efdigital/ll-xceed-v2/components/coaching/goals-list.gts';
import type CoachingCoacheeCohortGoalsController from '@efdigital/ll-xceed-v2/controllers/coaching/coachee/cohort/goals';
import type { CoachingCoacheeCohortGoalsModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/goals';
import { accessibleScrollBehavior } from '@efdigital/ll-xceed-v2/utils/application/scroll';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import { array } from '@ember/helper';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortGoalsSignature {
  Args: {
    model: CoachingCoacheeCohortGoalsModel;
    controller: CoachingCoacheeCohortGoalsController;
  };
}

export default class CoachingCoacheeCohortGoals extends Component<CoachingCoacheeCohortGoalsSignature> {
  @service declare router: RouterService;
  @tracked showCreateForm = false;

  get isGoalDetail(): boolean {
    return (
      this.router.currentRouteName === 'coaching.coachee.cohort.goals.goal'
    );
  }

  get canAddGoal(): boolean {
    return Boolean(this.args.model.defaultPlan);
  }

  get shouldShowCreateForm(): boolean {
    return this.showCreateForm || this.args.controller.add === 'true';
  }

  revealCreateForm = () => {
    this.showCreateForm = true;
    window.setTimeout(() => this.focusCreateForm(), 0);
  };

  hideCreateForm = () => {
    this.showCreateForm = false;
    this.args.controller.add = null;
  };

  focusCreateForm = () => {
    document.getElementById('goal-create')?.scrollIntoView({
      behavior: accessibleScrollBehavior(),
      block: 'start',
    });
    document.getElementById('goal-create-title')?.focus();
  };

  <template>
    {{#if this.isGoalDetail}}
      {{outlet}}
    {{else}}
      {{pageTitle "Goals"}}

      <div class={{PAGE_WRAPPER}}>
        <Heading @size="lg" @text="Goals" @class="mb-4" />

        <GoalTracker
          @goals={{@model.goals}}
          @milestones={{@model.milestones}}
          @canAddGoal={{this.canAddGoal}}
          @onAddGoals={{this.revealCreateForm}}
          @programId={{@model.program_id}}
          @cohortId={{@model.cohort_id}}
          @role="coachee"
        />

        <GoalsList
          @goals={{@model.goals}}
          @milestones={{@model.milestones}}
          @plan={{@model.defaultPlan}}
          @ownerUserId={{@model.ownerUserId}}
          @role="coachee"
          @goalRoute="coaching.coachee.cohort.goals.goal"
          @goalRouteModels={{array @model.program_id @model.cohort_id}}
          @showCreateForm={{this.shouldShowCreateForm}}
          @onGoalCreated={{this.hideCreateForm}}
          @onCloseCreateForm={{this.hideCreateForm}}
        />
      </div>
    {{/if}}
  </template>
}
